<template>
  <fo-layout class="white-bg">
    <div class="home-logink">
      <a-row :gutter='30'>
        <a-col class="colmb ta-c" v-for="(e, i) of data" :key="i" :href="e.client_link_url" :span='4'>
          <img class="img" width="100%" :src="e.client_logo" alt="">
        </a-col>
      </a-row>
    </div>
    <div class="ta-c boglinkbutton" v-if="total > data.length">
      <a-button @click="uploadMore" class="fo-small-btn fs-16 mt-12" type="primary">加载更多</a-button>
    </div>
  </fo-layout>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      data: [],
      total: 0,
      cond: {
        page_num: 1,
        page_size: 12
      }
    }
  },
  mounted () {
    this.readList()
  },
  methods: {
    uploadMore () {
      this.cond.page_num += 1
      this.readList()
    },
    readList () {
      this.loading = true
      this.get({
        url: 'clientRead',
        data: this.cond
      }, (res) => {
        this.loading = false
        for (var i of res.data.items) {
          this.data.push(i)
        }
        this.total = res.data.total
      })
    }
  }
}
</script>

<style lang="less">
  /* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  .home-logink {
    text-align: center;
    .colmb {
     width: 124px;
     display: inline-block;
     img {
      width: 100px;
      height: 100px;
      text-align: center;
      padding: 20px 20px;
     }
    }
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  .home-logink {
    .colmb {
      margin-bottom: 50px;
    }
    img {
      width: 100px;
      height: 100px;
    }
  }
  .boglinkbutton {
    padding-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/loglink.vue